import React from 'react';
import './PageShell.css';

/**
 * PageShell - Page wrapper with consistent padding and max-width
 * Supports hero layouts (left content, right visual)
 */
export const PageShell = ({
  children,
  variant = 'default', // 'default', 'hero', 'full'
  className = '',
  ...props
}) => {
  const classes = `page-shell page-shell-${variant} ${className}`.trim();

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

/**
 * HeroLayout - Two-column hero layout (content left, visual right)
 */
export const HeroLayout = ({
  left,
  right,
  className = '',
  ...props
}) => {
  return (
    <div className={`hero-layout ${className}`.trim()} {...props}>
      <div className="hero-layout-left">
        {left}
      </div>
      {right && (
        <div className="hero-layout-right">
          {right}
        </div>
      )}
    </div>
  );
};

PageShell.Hero = HeroLayout;

export default PageShell;
